<mat-card>
  <mat-card-header>
    <mat-card-title>{{ 'title.my_document_moha'| translate}}</mat-card-title>
  </mat-card-header>
  <mat-card-content class="mb-3 mat-card-content-contract-sm">
    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "title.search_info" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <form (ngSubmit)="onFilterData(0, paginate.pageSize)" class="pb-3">
          <div class="row">
         
            <!-- Tên hoặc mã hợp đồng -->
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <input type="text" matInput
                  [placeholder]="'search_form.doc_name_or_code' | translate"
                  (focusout)="trimInputText('nameOrCode')"
                  name="nameOrCode" [(ngModel)]="documents.nameOrCode"
                  maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.nameOrCode" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="documents.nameOrCode=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
         
            <!-- Hợp đồng cha -->
            <!-- <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <input type="text" matInput
                  [placeholder]="'form.doc_reference' | translate"
                  (focusout)="trimInputText('parentId')"
                  name="parentId" [(ngModel)]="documents.parentId"
                  maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.parentId" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="documents.parentId=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div> -->
         
            <!-- Loại hợp đồng (service type) -->
            <!-- <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{ 'form.digital_contract.document_type' | translate }}</mat-label>
                <mat-select #serviceTypeSelect (focusout)="(checkFocus = true)"
                  (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, serviceTypeSelect)"
                  name="type" [(ngModel)]="documents.type">
         
                  <mat-option>
                    <ngx-mat-select-search [noEntriesFoundLabel]="'autocomplete.suggestion' | translate"
                      [placeholderLabel]="'search_form.search' | translate"
                      [formControl]="serviceTypeByEnterpriseFilterCtrl">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let serviceType of filteredServiceTypeByEnterprise | async" [value]="serviceType.id"
                    (click)="this.commonService.closeDropdownList(this.serviceTypeSelect)">
                    {{serviceType.name}}
                  </mat-option>
                </mat-select>
                <button mat-button *ngIf="documents.type" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="documents.type=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div> -->
         
            <!-- Mã tài liệu cha (moha) -->
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <input type="text" matInput
                  [placeholder]="'search_form.doc_name_or_code_parent_moha' | translate"
                  (focusout)="trimInputText('contractEnterpriseFilter')"
                  name="contractEnterpriseFilter" [(ngModel)]="documents.contractEnterpriseFilter"
                  maxlength="200" autocomplete="off">
                <button mat-button *ngIf="documents.contractEnterpriseFilter" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="documents.contractEnterpriseFilter=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
         
            <!-- Ngày hiệu lực từ - đến -->
            <div class="d-flex w-50">
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="picker1"
                    [placeholder]="'search_form.effective_time_from' | translate"
                    [max]="documents.effectiveTo"
                    name="effectiveFrom" [(ngModel)]="documents.effectiveFrom"
                    (input)="effectiveField = 'effectiveFrom'"
                  >
                  <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                  <mat-datepicker #picker1></mat-datepicker>
                  <button mat-button *ngIf="documents.effectiveFrom" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.effectiveFrom=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="picker2"
                    [placeholder]="'search_form.effective_time_to' | translate"
                    [min]="documents.effectiveFrom"
                    name="effectiveTo" [(ngModel)]="documents.effectiveTo"
                    (input)="effectiveField = 'effectiveTo'"
                  >
                  <mat-datepicker-toggle matSuffix [for]="picker2"></mat-datepicker-toggle>
                  <mat-datepicker #picker2></mat-datepicker>
                  <button mat-button *ngIf="documents.effectiveTo" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.effectiveTo=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
         
            <!-- Ngày hết hiệu lực -->
            <div class="d-flex w-50">
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="picker3"
                    [placeholder]="'search_form.expire_time_from' | translate"
                    [max]="documents.expireTimeTo"
                    name="expireTimeFrom" [(ngModel)]="documents.expireTimeFrom"
                    (input)="expiredField = 'expireTimeFrom'"
                  >
                  <mat-datepicker-toggle matSuffix [for]="picker3"></mat-datepicker-toggle>
                  <mat-datepicker #picker3></mat-datepicker>
                  <button mat-button *ngIf="documents.expireTimeFrom" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.expireTimeFrom=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
              <div class="col-6">
                <mat-form-field class="w-100">
                  <input matInput [matDatepicker]="picker4"
                    [placeholder]="'search_form.expire_time_to' | translate"
                    [min]="documents.expireTimeFrom"
                    name="expireTimeTo" [(ngModel)]="documents.expireTimeTo"
                    (input)="expiredField = 'expireTimeTo'"
                  >
                  <mat-datepicker-toggle matSuffix [for]="picker4"></mat-datepicker-toggle>
                  <mat-datepicker #picker4></mat-datepicker>
                  <button mat-button *ngIf="documents.expireTimeTo" type="button" matSuffix mat-icon-button
                    aria-label="Clear" (click)="documents.expireTimeTo=''">
                    <mat-icon>close</mat-icon>
                  </button>
                </mat-form-field>
              </div>
            </div>
         
            <!-- Trạng thái -->
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{'search_form.status' | translate}}</mat-label>
                <mat-select #statusSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, statusSelect)" id="status"
                  name="status" [(ngModel)]="documents.status">
                  <mat-option [value]="''" selected (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="1"
                    (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.draft' | translate}}</mat-option>
                  <mat-option [value]="2"
                    (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.processing' | translate}}</mat-option>
                  <mat-option [value]="5"
                    (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.cancelled' | translate}}</mat-option>
                  <mat-option [value]="3"
                    (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'search_form.denied_sign' | translate}}</mat-option>
                  <mat-option [value]="8"
                    (click)="this.commonService.closeDropdownList(this.statusSelect)">
                    {{'contract_share_partner.issued' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
         
            <!-- UUID Hợp đồng -->
            <div class="col-md-6 col-lg-3">
              <mat-form-field class="w-100">
                <input type="text" matInput [placeholder]="'search_form.uuid_contract' | translate"
                  name="uuidContractMoha" [(ngModel)]="documents.uuidContractMoha" maxlength="50"
                  autocomplete="off"
                  (blur)="trimInputText('uuidContractMoha')">
                <button mat-button *ngIf="documents.uuidContractMoha" type="button" matSuffix mat-icon-button
                  aria-label="Clear" (click)="documents.uuidContractMoha=''">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
            </div>
         
            <!-- Trạng thái chứng thực -->
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{'contract_terminate.status_sign' | translate}}</mat-label>
                <mat-select #formTypeSelect (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, formTypeSelect)" id="mohaConfirmStatus"
                  name="mohaConfirmStatus" [(ngModel)]="documents.mohaConfirmStatus">
                  <mat-option [value]="''" selected
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="1"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'contract_terminate.no_sign' | translate}}</mat-option>
                  <mat-option [value]="2"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'contract_terminate.signing' | translate}}</mat-option>
                  <mat-option [value]="3"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'contract_terminate.failed' | translate}}</mat-option>
                  <mat-option [value]="5"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'search_form.cancelled' | translate}}</mat-option>
                  <mat-option [value]="6"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelect)">
                    {{'contract_terminate.signed' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
         
            <!-- Trạng thái gửi lên Nền tảng HDLD -->
            <div class="col-lg-3 col-md-6">
              <mat-form-field class="w-100">
                <mat-label>{{'contract_terminate.status_send_up' | translate}}</mat-label>
                <mat-select #formTypeSelectSend (focusout)="(checkFocus = true)" (selectionChange)="checkFocus = false"
                  (focus)="commonService.openComboBox(checkFocus, formTypeSelectSend)" id="mohaStatus"
                  name="mohaStatus" [(ngModel)]="documents.mohaStatus">
                  <mat-option [value]="''" selected
                    (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                    {{'form.select_all' | translate}}</mat-option>
                  <mat-option [value]="1"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                    {{'contract_terminate.no_send' | translate}}</mat-option>
                  <mat-option [value]="2"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                    {{'contract_terminate.sending' | translate}}</mat-option>
                  <mat-option [value]="3"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                    {{'contract_terminate.failed' | translate}}</mat-option>
                  <mat-option [value]="4"
                    (click)="this.commonService.closeDropdownList(this.formTypeSelectSend)">
                    {{'contract_terminate.sent' | translate}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
         
            <!-- <div class="d-flex col-12 justify-content-end align-items-center">
              <span style="margin-right: 10px;">{{ 'search_form.null_expired_date' | translate }}</span>
              <mat-checkbox name="nullExpiredDate" [(ngModel)]="documents.nullExpiredDate"
                (change)="checkboxNull()" class="null-expired-date"></mat-checkbox>
            </div> -->

            <!-- button tìm kiếm -->
          <div class="row col-lg-12 mt-3">
            <div class="col-lg-12 d-flex justify-content-center">
              <button mat-stroked-button color="primary" type="submit" (click)="onClickBtnFilter()" appTrackEvent="w.btn.hd_ky_duyet.tim_kiem"
                      >
                <mat-icon class="mr-0" style="font-weight: 900;">search</mat-icon>
                {{'enterprise_document_template.buttons.search' | translate}}
              </button>
            </div>
          </div>
          </div>
        </form>
      </mat-expansion-panel>
      
    </mat-accordion>

    <mat-accordion #accordion="matAccordion" [multi]="true">
      <mat-expansion-panel expanded="true" class="mt-3">
        <mat-panel-title class="mat-panel-title mat-panel-title-sm mt-3 d-flex justify-content-between align-items-center list-title">
          <!-- Header title -->
          <div  class="title col-xs-12 pl-0">
            <span class="mt-4">{{'enterprise_contract.list_contract_moha' | translate}}
              ({{paginate.totalRow}}), {{'enterprise_contract.selected_title' | translate}}: {{dataSelected.length}}
            </span>
          </div>
          <!--  Button  -->
          <div class="d-flex buttonMD align-items-center list-title list-title-apru">
            <div class="list-btn" *ngIf="!isSigning; else showSigningBackground">
              <!-- Button -->
              <!-- <button class="mr-1 list-btn-1" mat-stroked-button color="primary" (click)="openSignSlot()" [disabled]="countCheck == 0 || this.dataSource == null || this.dataSource.data == null
              || this.dataSource.data.value == null
              || this.dataSource.data.value.length === 0" appTrackEvent="w.btn.hd_ky_duyet.ky_theo_lo">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_lot' | translate}}
              </button> -->
              <!-- Button -->
              <!-- <button class="button-sign-all " (click)="openSignAll()" [disabled]="this.dataSource == null
              || this.dataSource.data == null
              || this.dataSource.data.value == null
              || this.dataSource.data.value.length === 0
              || this.oldData.status === 3
              || this.oldData.status === 4
              || (this.oldData.status === null && this.waitSignDocsCount === 0)" mat-stroked-button color="primary" appTrackEvent="w.btn.hd_ky_duyet.ky_tat_ca_hd">
                <mat-icon class="mr-0">gesture</mat-icon>
                {{'button.sign_all' | translate}}
              </button> -->

              <button class="pull-right ml-1 list-btn " mat-stroked-button color="primary" type="button" appTrackEvent="w.btn.hd_ky_duyet.khac"
                      [matMenuTriggerFor]="menuFeature" >
                <mat-icon>apps</mat-icon>
                {{'button.more_feature' | translate}}
              </button>
            </div>

            <ng-template #showSigningBackground>
              <div layout-align="center center end-start">
                <div class="row">
                  <div class="col-11">
                    <span>{{'messages.signing_progress' | translate}} {{processedPercent}}%</span>
                    <mat-progress-bar mode="determinate" [value]="processedPercent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                  <div class="col-1" layout="row" layout-align="end center">
                    <button mat-icon-button color="primary" (click)="handleSingingProcess()" matTooltip="">
                      <mat-icon>gesture</mat-icon>
                    </button>
                  </div>
                </div>
              </div>
            </ng-template>

            <mat-menu #menuFeature="matMenu" >

              <button class="btn1-mine hideicon other-button" mat-menu-item   type="button" (click)=" $event.stopPropagation()"  [matMenuTriggerFor]="menuColumn"
                      *ngIf="!commonService.getIsLockedEnterprise()"
                      style="border-bottom: 1px solid rgb(213 213 213) !important;">
                <mat-icon class="mr-0 other-button" >more_vert</mat-icon>
                {{'bodytable.status_column' | translate}}
              </button>

              <button class="btn1-mine" appTrackEvent="w.btn.hd_ky_duyet.khac.tai_hd"
                      [ngClass]="{'other-button': this.dataSelected.length !== 0 }"
                      [disabled]=" this.dataSelected.length === 0" mat-menu-item class="other-button" (click)="multiDownload()">
                <mat-icon class="mr-0 "  [ngClass]="{'other-button': this.dataSelected.length !== 0 }">save_alt</mat-icon>
                {{'button.downloadContract' | translate}}
              </button>
            </mat-menu>

            <mat-menu #menuColumn="matMenu"  >
              <mat-checkbox style="margin: 0px 15px" [(ngModel)]="isCheckedAllColumn" (click)="$event.stopPropagation()" (change)="onAllColumnCheckboxChange(isCheckedAllColumn)"
              >{{ 'form.select_all_group' | translate}}</mat-checkbox>
              <div *ngFor="let option of columnDefinitions">
                <mat-checkbox style="margin: 0px 15px" [(ngModel)]="option.default" (change)="onCheckboxChange(option)" (click)="$event.stopPropagation()"
                              [checked]="option.default" *ngIf="!option.check"
                >{{ option.name | translate}}</mat-checkbox>
              </div>
            </mat-menu>

          </div>

        </mat-panel-title>

        <div class="mat-table-container" style=" display: block; max-height: 590px">
          <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)" [ngStyle]="{'min-width': tableWidth + 'px'}">
            <!-- check -->
            <ng-container matColumnDef="check">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
                <mat-checkbox [(ngModel)]="checkAll" (change)="checkAllDocument()" color="primary"></mat-checkbox>
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                <mat-checkbox color="primary" [(ngModel)]="element.checked" (change)="onSelectionChange()">
                </mat-checkbox>
              </mat-cell>
            </ng-container>

            <!-- STT -->
            <ng-container matColumnDef="STT">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.No' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
                        (click)="$event.stopPropagation()">
                {{element.STT}}
              </mat-cell>
            </ng-container>

            <!-- UUID Hợp đồng -->
            <ng-container matColumnDef="uuidContractMoha">
              <mat-header-cell *matHeaderCellDef style="max-width: 30%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.uuid_contract' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.uuidContractMoha }}"
                class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()" style="max-width: 30%;">
                <span class="fix-width">{{ element.uuidContractMoha }}</span>
              </mat-cell>
            </ng-container>

            <!-- Tài liệu Column -->
            <ng-container matColumnDef="contractName">
              <mat-header-cell *matHeaderCellDef mat-sort-header style="width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.document_code_name' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{element.name}}" (click)="$event.stopPropagation()"
                        class="mat-cell-non-boder-right-bottom" style="width: 20%;">
                <span class="fix-width">{{element.name}}</span>
              </mat-cell>
            </ng-container>

            <!-- Hợp đồng văn bản liên kết Column -->
            <!-- <ng-container matColumnDef="parent">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 20%;">
                {{'headertable.document_parent' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allParentCode }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allParentCode }}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Khách hàng Column -->
            <!-- <ng-container matColumnDef="allName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allName }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()">
                <span class="fix-width">{{ element.allName}}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Loai hop dong Column -->
            <!-- <ng-container matColumnDef="serviceTypeName">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'search_form.type_of_doc' | translate}}
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom" matTooltip="{{ element.contractType }}"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.contractType }}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Email các bên ký hợp đồng Column -->
            <!-- <ng-container matColumnDef="allEmail">
              <mat-header-cell *matHeaderCellDef style="max-width: 20%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.contract_parties_email' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.allEmail }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 20%;">
                <span class="fix-width">{{ element.allEmail }}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Trạng thái Column -->
            <!-- <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'form.status_process' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSING && element.mohaConfirmStatus === 2"
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_no_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSED" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.status === contractUserStatus.PROCESSING && (element.mohaConfirmStatus === 5 || element.mohaConfirmStatus === 3)"
                  style="margin-right: 0px;">{{'search_form.contract_user_status_stop_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.DAEMON_PROCESSING && element.mohaConfirmStatus === 2"
                        [nzColor]="'orange'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_daemon_process' | translate}}</nz-tag>
              </mat-cell>
            </ng-container> -->

            <!-- Ngày hiệu lực column -->
            <ng-container matColumnDef="effectiveDate">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center mat-cell-non-boder-right-bottom"
                               mat-sort-header
                               style="max-width: 10%;">
                <span>
                  {{'headertable.document_date' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell (click)="$event.stopPropagation()" *matCellDef="let element"
                        class="mat-cell-non-boder-right-bottom number-cell-center"
                        matTooltip="{{element.effectiveDate | dateformat}}"
                        style="max-width: 10%;">
                <span class="fix-width">{{ element.effectiveDate | dateformat}}</span>
              </mat-cell>
            </ng-container>

            <!-- Trạng thái kí kết khác  -->
            <!-- <ng-container matColumnDef="statusOther">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.other_signing_parties_status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.STOP_PROCESS.toString()" style="margin-right: 0px;">
                  {{'search_form.contract_user_status_stop_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.NO_PROCESS.toString()" style="margin-right: 0px;">
                  {{'form.document_status_wait' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.PROCESSING.toString()" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'messages.sign_processing' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.REJECTED.toString()" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.PROCESSED.toString()" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'form.document_status_signed' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther === enumContractUserStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}</nz-tag>
                <nz-tag *ngIf="element.statusOther == enumContractUserStatus.DAEMON_PROCESSING.toString()" [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.connecting' | translate}}</nz-tag>
              </mat-cell>
            </ng-container> -->

            <!--Ngày hết hiệu lực Column -->
            <ng-container matColumnDef="expiredDate">
              <mat-header-cell *matHeaderCellDef
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="max-width: 11%;">
                {{'enterprise-certificate_management.lbl_end_date' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="element.expiredDate | dateformat"
                        (click)="$event.stopPropagation()" style="max-width: 11%;">
                <span class="fix-width">{{ element.expiredDate | dateformat}}</span>
              </mat-cell>
            </ng-container>

            <!-- Bên lập -->
            <ng-container matColumnDef="createdUser">
              <mat-header-cell *matHeaderCellDef style="max-width: 11%;" mat-sort-header
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                <span>
                  {{'enterprise_contract.table_headers.created_enterprise' | translate}}
                </span>
              </mat-header-cell>
              <mat-cell *matCellDef="let element" matTooltip="{{ element.createdUser }}"
                        (click)="$event.stopPropagation()" class="mat-cell-non-boder-right-bottom"
                        style="max-width: 11%;">
                <span class="fix-width">{{ element.createdUser }}</span>
              </mat-cell>
            </ng-container>

            <!-- nguoi lap -->
            <!-- <ng-container matColumnDef="createdBy">
              <mat-header-cell *matHeaderCellDef style="max-width: 7%;"
                               class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'enterprise_contract.table_headers.created_by' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"  matTooltip="{{ element.createdBy }}"
                        class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                        style="max-width: 7%; justify-content: center;">
                <span class="fix-width">{{ element.createdBy }}</span>
              </mat-cell>
            </ng-container> -->

            <!-- Hình thức tài liệu Column -->
            <!-- <ng-container matColumnDef="formType">
              <mat-header-cell *matHeaderCellDef
                              class="mat-header-cell-center mat-cell-non-boder-right-bottom" style="width: 150px;">
                {{'contract_terminate.form_type' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-cell-non-boder-right-bottom number-cell-center"
                        [matTooltip]="getFormType(element.formType)"
                        style="width: 150px;">
                <span class="fix-width">{{ getFormType(element.formType) }}<span class="test-deploy-cicd"></span></span>
              </mat-cell>
            </ng-container> -->

            <!-- Trạng thái Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell *matHeaderCellDef class="doc-status-col mat-cell-non-boder-right-bottom"
                               style="max-width: 10%;">
                {{'form.status' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                        class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center"
                        style="max-width: 10%;"
                        (click)="$event.stopPropagation()">
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSING && element.mohaConfirmStatus === 2"
                        [nzColor]="'blue'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_no_process' | translate}}</nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.PROCESSED" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.REJECTED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_rejected' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.CANCELLED" [nzColor]="'red'"
                        style="margin-right: 0px;">{{'search_form.cancelled' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.FINISHED_DIGITAL" [nzColor]="'green'"
                        style="margin-right: 0px;">{{'contract_share_partner.issued' | translate}}
                </nz-tag>
                <nz-tag
                  *ngIf="element.status === contractUserStatus.PROCESSING && (element.mohaConfirmStatus === 5 || element.mohaConfirmStatus === 3)"
                  style="margin-right: 0px;">{{'search_form.contract_user_status_stop_process' | translate}}
                </nz-tag>
                <nz-tag *ngIf="element.status === contractUserStatus.DAEMON_PROCESSING && element.mohaConfirmStatus === 2"
                        [nzColor]="'orange'"
                        style="margin-right: 0px;">{{'search_form.contract_user_status_sign_daemon_process' | translate}}</nz-tag>
              </mat-cell>
            </ng-container>

            <!-- Trạng thái chứng thực  -->
            <ng-container matColumnDef="mohaConfirmStatus">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.status_sign' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                (click)="$event.stopPropagation()">
                <nz-tag *ngIf="+element.mohaConfirmStatus === 1"
                  style="margin-right: 0px;">
                  {{'contract_terminate.no_sign' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.signing' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaConfirmStatus === 4"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.signing' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.failed' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 5"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.cancel' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.mohaConfirmStatus === 6"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.signed' | translate}}
                </nz-tag>              
              </mat-cell>
            </ng-container>


            <!-- Trạng thái gửi Nền tảng HĐLĐ -->
            <ng-container matColumnDef="mohaStatus">
              <mat-header-cell *matHeaderCellDef style="max-width: 10%;"
                class="mat-header-cell-center mat-cell-non-boder-right-bottom">
                {{'headertable.status_send' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element"
                class="doc-status-col mat-cell-non-boder-right-bottom number-cell-center" style="max-width: 10%;"
                (click)="$event.stopPropagation()">
                <nz-tag *ngIf="+element.mohaStatus === 1"
                  style="margin-right: 0px;">
                  {{'contract_terminate.no_send' | translate}}</nz-tag>
                <nz-tag *ngIf="+element.mohaStatus === 2"
                  [nzColor]="'blue'" style="margin-right: 0px;">
                  {{'contract_terminate.sending' | translate}}</nz-tag>
                  <nz-tag *ngIf="+element.mohaStatus === 3"
                  [nzColor]="'red'" style="margin-right: 0px;">{{'contract_terminate.failed' | translate}}
                </nz-tag>
                <nz-tag *ngIf="+element.mohaStatus === 4"
                  [nzColor]="'green'" style="margin-right: 0px;">{{'contract_terminate.sent' | translate}}
                </nz-tag>
              </mat-cell>
            </ng-container>

            <!-- Tác động Column -->
            <ng-container matColumnDef="action" class="mat-column-symbol ">
              <mat-header-cell *matHeaderCellDef class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                               style="min-width: 100px">
                {{'headertable.action' | translate}}
              </mat-header-cell>
              <mat-cell *matCellDef="let element" class="mat-header-cell-center action-col-3 mat-cell-non-border-bottom"
                        style="min-width: 100px" (click)="$event.stopPropagation()">
                <button mat-icon-button (click)="viewDetail(element)" appTrackEvent="w.btn.hd_ky_duyet.xem_chi_tiet"
                        matTooltip="{{'enterprise_contract.buttons.view' | translate}}">
                  <mat-icon>visibility</mat-icon>
                </button>
                <button mat-icon-button (click)="openPDFByBrowser(element)" appTrackEvent="w.btn.hd_ky_duyet.tai">
                  <mat-icon matTooltip="{{'enterprise_contract.buttons.download' | translate}}">save_alt
                  </mat-icon>
                </button>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: false"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" matRipple class="element-row" [cdkDetailRow]="row"
                     [cdkDetailRowTpl]="tpl" (toggleChange)="onToggleChange($event,row)">
            </mat-row>
          </mat-table>
        </div>

        <ng-template #tpl let-element>
          <div class="mat-row detail-row" [@detailExpand] style="overflow: hidden">

          </div>
        </ng-template>

        <!-- Pagination -->
        <app-pagination [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
        </app-pagination>
      </mat-expansion-panel>
    </mat-accordion>

  </mat-card-content>
</mat-card>
